import { render, staticRenderFns } from "./EnlargeableImage.vue?vue&type=template&id=539b9c7d&scoped=true&"
import script from "./EnlargeableImage.vue?vue&type=script&lang=js&"
export * from "./EnlargeableImage.vue?vue&type=script&lang=js&"
import style0 from "./EnlargeableImage.vue?vue&type=style&index=0&id=539b9c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b9c7d",
  null
  
)

export default component.exports